import { useState, useEffect } from 'react'
import { fetchOption } from '../helpers/fetchOption';

export const useFetchOption = ( geoserverUrl, layerName, variableName, option ) => {

    const [variable, setVariable] = useState('');

    useEffect( () => {
        fetchOption( geoserverUrl, layerName, variableName, option )
            .then( data => {              
                setVariable(data);
            })
    }, [layerName, variableName, option])
    return variable;
}